
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
let lity = require('lity');
require('slick-carousel');
window.Vue = require('vue');
window.Vue = window.Vue.default || window.Vue;
const Vue = window.Vue;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('fraud-quiz-component', require('./components/FraudQuizComponent.vue').default);

Vue.component('v-style', {
	render: function (createElement) {
		return createElement('style', this.$slots.default);
	}
});

const app = new Vue({
    el: '#app'
});

// Site Navigaton 
// var distance = $(".navbar-primary").offset().top + 1;
var distance = 10;
var $window = $(window);



// lity lightbox
$(document).on('lity:ready', function(event, instance) {
	
	if($(window).width() < 768) {
		let $video = $("iframe")[0];
		if ($video.requestFullscreen) {
			$video.requestFullscreen();
		} else if ($video.mozRequestFullScreen) { /* Firefox */
			$video.mozRequestFullScreen();
		} else if ($video.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
			$video.webkitRequestFullscreen();
		} else if ($video.msRequestFullscreen) { /* IE/Edge */
			$video.msRequestFullscreen();
		}
		screen.orientation.lock("landscape");
	}
	$('.lity-container iframe').attr('title', 'TITLE OF CONTENT');
});


$window.scroll(function() {
	// console.log('Scrolling!');

	if ($window.scrollTop() <= distance) {
		$(".navbar-primary").removeClass("nav-scroll");
		return;
	}

	$(".navbar-primary").addClass("nav-scroll");
});
$window.scroll();

// FAQ-cards Animation
$(".js-collapsible").click(function() {
	$(this).toggleClass('open');
	// $(this).find(".answer").slideToggle(300);
	
	let data = sessionStorage.getItem('faqs.opened');
	let faqs = JSON.parse(data);
	if ( ! Array.isArray(faqs)) {
		faqs = [];
	}
	
	if ($(this).hasClass('open')) {
		let faq_id = $(this).data('id');
		if (faqs.indexOf(faq_id) == -1) {
			console.log('faq open tracked for ID: '+faq_id);
			faqs.push(faq_id);
			sessionStorage.setItem('faqs.opened', JSON.stringify(faqs));
			
			dataLayer.push({
				'event': 'faq',
				'action': 'opened',
				'id': faq_id,
			});
		}
	}
});

let window_width = $(window).width() ||  window.innerWidth;
let sm = 576;
let md = 768;
let lg = 992;
let xl = 1200;

let $consequenceSlick = $('.consequence-slick');
let $homeCardSlick = $('.cards-home > .row');
let slideSettings = {
	autoplay: false,
	dots: true,
	prevArrow: false,
	nextArrow: false,
	slidesToShow: 1,
	slidesToScroll: 1
};


$(document).ready(function() {
	$(".js-open-menu").click(function () {
		$(this).toggleClass("closed");
		$('#navbarNavAltMarkup').collapse('toggle');
	});
	
	// slick 
	if(window_width < md) {
		$consequenceSlick.not('.slick-initialized').slick(slideSettings);
		$homeCardSlick.not('.slick-initialized').slick(slideSettings);
	}

	// "what can you do" hiding ul area
	setTimeout(hideList, 100);
});


$(window).resize(function() {
	window_width = $(window).width() ||  window.innerWidth;
	if(window_width < md) {
		$consequenceSlick.not('.slick-initialized').slick(slideSettings);
		$homeCardSlick.not('.slick-initialized').slick(slideSettings);
	} else {
		if($consequenceSlick.hasClass('slick-initialized')) {
			$consequenceSlick.slick("unslick");
		}
		if($homeCardSlick.hasClass('slick-initialized')) {
			$homeCardSlick.slick("unslick");
		}
	}

	hideList();


});

// Home Banner Video Modal
$('.js-btn-modal').click(function () {
	var played = sessionStorage.getItem('video.played');
	if ( ! played && typeof(dataLayer) !== 'undefined') {
		console.log('video play tracked');
		sessionStorage.setItem('video.played', true);
		dataLayer.push({
			'event': 'video',
			'action': 'played',
			'description': 'Homepage Banner Promo Video',
		});
	}

	$('.modal').modal('show');
	$("#video-frame")[0].src += "?autoplay=1"; // mute=1 is required or browsers normally stop the autoplay
	
});

$('#video-modal').on('hidden.bs.modal', function () {
	$("#video-frame")[0].src = $("#video-frame")[0].src.replace('?autoplay=1','');
});

$('.js-language-toggle input[name="language"]').on('change', function(e){
	// @TODO remove this functionality in favour of anchor tags
	console.log(this.value);
	window.location = this.value;
});

// what can you do collapsing btn
let whatYouCanDo = ".cards-what-can-you-do";

$(whatYouCanDo + ' .view-more').click(function(e){
	e.preventDefault();

	$selectBody =  $(this).prev();
	let ulHeight = $selectBody.find('ul').outerHeight(true);
	let isOpened = $selectBody.hasClass('isOpened');

	if(isOpened) {
		$selectBody.removeClass('isOpened');
	} else {
		$selectBody.addClass('isOpened');
	}

	let operator = isOpened ? -1 : 1;
	// if()
	$(this).html(isOpened ? ($('html').is(':lang(fr)') ? 'EN SAVOIR PLUS' : 'SEE MORE') : ($('html').is(':lang(fr)') ?  'FERMER' : 'CLOSE' ));
	$selectBody.animate({"height": `${$selectBody.height() + operator * ulHeight}`  + "px"});
	$selectBody.focus();
	$(this).attr('tabIndex', -1);
});



// "what can you do" hiding ul area
function hideList() {
	let $cardBody = $(whatYouCanDo + ' .card-body');
	$cardBody.each(function(){
		$body = $(this);
		let h5Height = $body.find('h5').outerHeight(true);
		let pHeight = $body.find('p').outerHeight(true);
		let ulHeight = $body.find('ul').outerHeight(true);
		
		if($body.hasClass('isOpened')) {
			$body.height(h5Height + pHeight + ulHeight);
		} else {
			$body.height(h5Height + pHeight);
		}
	});
}



$("#toggle").click(function(e) {
	e.preventDefault();
	let $numbers = $("#numbers");
	if($numbers.hasClass("toggled")) {
		$numbers.animate({"height": "200px"}).removeClass("toggled");
	} else {
		$numbers.animate({"height": "100px"}).addClass("toggled");
	}
});


var pageURL = window.location.href;
var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1);
sessionStorage.setItem('association.reference', JSON.stringify(lastURLSegment));

// GA Events implementation event naming conventions
/*
FAQs Tracking
--------------------------
ga('send', 'event', {
  'eventCategory': 'faq',
  'eventAction': 'opened',
  'eventLabel': event.target.href, // what page the FAQ was triggered on
  'eventValue': 55
});

NOTE: "eventValue" is the ID of the FAQ

Quiz/Questions Tracking
--------------------------
ga('send', 'event', {
  'eventCategory': 'question',
  'eventAction': 'answered',
  'eventLabel': 'Quiz',
  'eventValue': 55
});

NOTE: "eventValue" is the ID of the question. 


Promo Video

ga('send', 'event', {
  'eventCategory': 'video',
  'eventAction': 'played',
  'eventLabel': 'Homepage Banner Promo Video',
});
*/